// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__BQxaq","content":"RecentSearches_content__Ty8f7"};